//GENERAL LEDGER IMPORTS
import GLA0100 from "../pages/glAndAccounting/generalLedger/ManageGLAccount";
import EditGLAccount from "../pages/glAndAccounting/generalLedger/EditGLAccount";
import GLView from "../pages/glAndAccounting/generalLedger/DetailGLAccount";
import AddGLA0100 from "../pages/glAndAccounting/generalLedger/NewGLAccount";

//SUBLEDGER IMPORTS
import AddSubLedgerGLA0100 from "../pages/glAndAccounting/generalLedger/NewSubLedger";

//JOURNAL ENTRY IMPORTS
import GLA0200 from "../pages/glAndAccounting/journalEntry/ManageJournalEntry";
import AddGLA0200 from "../pages/glAndAccounting/journalEntry/AddJournalEntry";
import ViewGLA0200 from "../pages/glAndAccounting/journalEntry/DetailJournalEntry";
import SearchGLA0200 from "../pages/glAndAccounting/journalEntry/SearchJournalEntry";

//FINANCE RULES IMPORTS
import GLA0300 from "../pages/glAndAccounting/financeRules/ManageFinaceRules";
import AddGLA0300 from "../pages/glAndAccounting/financeRules/NewFinanceRules";
import ViewGLA0300 from "../pages/glAndAccounting/financeRules/DetailFinanceRules";
import EditGLA0300 from "../pages/glAndAccounting/financeRules/EditFinanceRules";

//GENERAL LEDGER MAPPING IMPORTS
import GLA0400 from "../pages/glAndAccounting/GLMapping/ManageGLMapping";
import NewGLA0400 from "../pages/glAndAccounting/GLMapping/NewGLMapping";
import ViewGLA0400 from "../pages/glAndAccounting/GLMapping/ViewGLMapping";
import EditGLA0400 from "../pages/glAndAccounting/GLMapping/EditGLMapping";

//ACCOUNTING RULES IMPORTS
import GLA0500 from "../pages/glAndAccounting/AccountingRules/ManageAccountingRules";
import ADDGLA0500 from "../pages/glAndAccounting/AccountingRules/NewAccountingRule";
import ViewGLA0500 from "../pages/glAndAccounting/AccountingRules/DetailAccountingRules"
import EditGLA0500 from "../pages/glAndAccounting/AccountingRules/EditAccountingRule";

//FREQUENT POSTING IMPORTS
import GLA0600 from "../pages/glAndAccounting/FrequentPosting/FrequentPosting";
import ViewGLA0600 from "../pages/glAndAccounting/FrequentPosting/ViewFrequentPosting";

//ACCRUALS IMPORT
import GLA0700 from "../pages/glAndAccounting/PeriodicAccruals/PeriodicAccruals";

//END OF CIRCLES IMPORTS
import GLA0800 from "../pages/glAndAccounting/EndOfCircle/ManageEndOfCircle";
import AddGLA0800 from "../pages/glAndAccounting/EndOfCircle/NewEndOfCircle";
import ViewGLA0800 from "../pages/glAndAccounting/EndOfCircle/DetailEndOfCircle";

//FUND MAPPING IMPORTS
import SearchGLA0900 from "../pages/glAndAccounting/fundMapping/FundMapping";
import GLA0900 from "../pages/glAndAccounting/fundMapping/ManageFundMapping";

//FUND SOURCE IMPORTS
import GLA1000 from "../pages/glAndAccounting/FundSource/ManageFundSource";
import ADDGLA1000 from "../pages/glAndAccounting/FundSource/NewFundSource";
import ViewGLA1000 from "../pages/glAndAccounting/FundSource/ViewFundSource"
import EditGLA1000 from "../pages/glAndAccounting/FundSource/EditFundSource";

//PROVISIONING ENTRIES IMPORTS
import GLA1100 from "../pages/glAndAccounting/Provisioning Entries/ManageProvisioningEntries";
import AddGLA1100 from "../pages/glAndAccounting/Provisioning Entries/NewProvisioningEntries";
import ViewGLA1100 from "../pages/glAndAccounting/Provisioning Entries/DetailProvisioningEntries";
import JournalGLA1100 from "../pages/glAndAccounting/Provisioning Entries/JournalEntries";

// CASA TO GL TRANSFER
import GLA1200 from "../pages/glAndAccounting/CASAToGlTransfer/AddCASAToGlTransfer"
import GLA1300 from "../pages/glAndAccounting/GlToCASATransfer/AddGlToCASATransfer";

export default [
  //GENERAL LEDGER
  {
    path: "/gla0100",
    component: GLA0100,
    isProtected: true,
  },
  {
    path: "/edit-gla0100",
    component: EditGLAccount,
    isProtected: true,
  },
  {
    path: "/view-gla0100",
    component: GLView,
    isProtected: true,
  },
  {
    path: "/add-gla0100",
    component: AddGLA0100,
    isProtected: true,
  },
  {
    path: "/add-subledger-gla0100",
    component: AddSubLedgerGLA0100,
    isProtected: true,
  },

  //JOURNAL ENTRY
  {
    path: "/gla0200",
    component: GLA0200,
    isProtected: true,
  },
  {
    path: "/add-gla0200",
    component: AddGLA0200,
    isProtected: true,
  },
  {
    path: "/view-gla0200",
    component: ViewGLA0200,
    isProtected: true,
  },
  {
    path: "/search-gla0200",
    component: SearchGLA0200,
    isProtected: true,
  },

  //FINANCE RULES
  {
    path: "/gla0300",
    component: GLA0300,
    isProtected: true,
  },
  {
    path: "/add-gla0300",
    component: AddGLA0300,
    isProtected: true,
  },
  {
    path: "/view-gla0300",
    component: ViewGLA0300,
    isProtected: true,
  },
  {
    path: "/edit-gla0300",
    component: EditGLA0300,
    isProtected: true,
  },

  //GENERAL LEDGER MAPPING
  {
    path: "/gla0400",
    component: GLA0400,
    isProtected: true,
  },
  {
    path: "/add-gla0400",
    component: NewGLA0400,
    isProtected: true,
  },
  {
    path: "/view-gla0400",
    component: ViewGLA0400,
    isProtected: true,
  },
  {
    path: "/edit-gla0400",
    component: EditGLA0400,
    isProtected: true,
  },

  //ACCOUNTING RULES
  {
    path: "/gla0500",
    component: GLA0500,
    isProtected: true,
  },
  {
    path: "/add-gla0500",
    component: ADDGLA0500,
    isProtected: true,
  },
  {
    path: "/view-gla0500",
    component: ViewGLA0500,
    isProtected: true,
  },
  {
    path: "/edit-gla0500",
    component: EditGLA0500,
    isProtected: true,
  },

  //FREQUENT POSTING 
  {
    path: "/gla0600",
    component: GLA0600,
    isProtected: true,
  },
  {
    path: "/view-gla0600",
    component: ViewGLA0600,
    isProtected: true,
  },

  //ACCRUALS
  {
    path: "/gla0700",
    component: GLA0700,
    isProtected: true,
  },

  //END OF CIRCLES
  {
    path: "/gla0800",
    component: GLA0800,
    isProtected: true,
  },
  {
    path: "/add-gla0800",
    component: AddGLA0800,
    isProtected: true,
  },
  {
    path: "/view-gla0800",
    component: ViewGLA0800,
    isProtected: true,
  },

  //FUND MAPPING
  {
    path: "/search-gla0900",
    component: SearchGLA0900,
    isProtected: true,
  },
  {
    path: "/gla0900",
    component: GLA0900,
    isProtected: true,
  },

  //FUND SOURCE
  {
    path: "/gla1000",
    component: GLA1000,
    isProtected: true,
  },
  {
    path: "/add-gla1000",
    component: ADDGLA1000,
    isProtected: true,
  },
  {
    path: "/view-gla1000",
    component: ViewGLA1000,
    isProtected: true,
  },
  {
    path: "/edit-gla1000",
    component: EditGLA1000,
    isProtected: true,
  },

  //PROVISIONING IMPORTS
  {
    path: "/gla1100",
    component: GLA1100,
    isProtected: true,
  },
  {
    path: "/add-gla1100",
    component: AddGLA1100,
    isProtected: true,
  },
  {
    path: "/view-gla1100",
    component: ViewGLA1100,
    isProtected: true,
  },
  {
    path: "/journal-gla1100",
    component: JournalGLA1100,
    isProtected: true,
  },

  // CASA TO GL TRANSFER
{
    path: "/gla1200",
    component: GLA1200,
    // isProtected: true,
  },
  // GL to CASA TRANSFER
{
    path: "/gla1300",
    component: GLA1300,
    // isProtected: true,
  },
];